export interface HealthBarProps {
  value: number;
  height?: number;
}

export function HealthBar({ value, height = 6 }: HealthBarProps) {
  const tone =
    value >= 75 ? 'var(--apm-ok)' : value >= 50 ? 'var(--apm-warn)' : 'var(--apm-risk)';
  const clamped = Math.max(0, Math.min(100, value));
  return (
    <div
      style={{
        height,
        background: 'var(--apm-bg-sunken)',
        borderRadius: 999,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: `${clamped}%`,
          height: '100%',
          background: tone,
          borderRadius: 999,
        }}
      />
    </div>
  );
}
